import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { FilterItemTypes } from "configs/types";
import { useAppSelector } from "store/index";

import Filter from "components/global/Filter/Filter";

import gridIcon from "assets/icons/grid-icon.svg";

interface Props {
  handleUpdateServices: (
    e: { value: string | number; label: string }[]
  ) => void;
  selectedServices: { value: string | number; label: string }[];
  handleApply: () => void;
}
const LogsFilter: React.FC<Props> = ({
  handleUpdateServices,
  selectedServices,
  handleApply,
}) => {
  const { t } = useTranslation();

  const servicesList = useAppSelector((store) => store.settings.services);

  const [services, setServices] = useState<
    { value: string | number; label: string }[]
  >([]);

  useEffect(() => {
    const result =
      servicesList?.map((el) => ({
        value: el,
        label: el,
      })) ?? [];
    setServices(result);
  }, [servicesList]);

  const handleApplyServices = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean
  ) => {
    handleUpdateServices(isDelete ? e : [...selectedServices, ...e]);
  };

  const handleClearFilters = () => {
    handleUpdateServices([]);
    handleApply();
  };

  const handleApplyFilters = () => {
    handleApply();
  };

  return (
    <Filter
      handleClear={handleClearFilters}
      handleApply={handleApplyFilters}
      filterItems={[
        {
          type: FilterItemTypes.multiselect,
          title: t("services"),
          boxTitle: t("services"),
          icon: gridIcon,
          itemsArray: services,
          activeItems: selectedServices,
          handleApply: handleApplyServices,
          disabled: services.length === 0,
        },
      ]}
    />
  );
};

export default LogsFilter;
